import { render } from "./ProductFilterItem.vue?vue&type=template&id=20936726&scoped=true"
import script from "./ProductFilterItem.vue?vue&type=script&lang=js"
export * from "./ProductFilterItem.vue?vue&type=script&lang=js"

import "./ProductFilterItem.vue?vue&type=style&index=0&id=20936726&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20936726"]])

export default __exports__